import { PreferredProviderRequestDto } from './types';

export const mapPreferredProviderDto = (
  consumerId: string,
  providerId: string
): PreferredProviderRequestDto => ({
  consumerId,
  preferredProviders: [{ corpProvId: providerId }]
});
